import { reduce } from "lodash";
import { EntryType, LocalisationEntry } from "PFTypes";

export const countMissingStrings = (localisation: LocalisationEntry[]) =>
  reduce(
    localisation,
    (counter, { type, value }) => {
      const { allStrings, missingStrings } =
        type === EntryType.Collection
          ? countMissingStrings(value)
          : { allStrings: 1, missingStrings: Number(!value) };

      return {
        allStrings: counter.allStrings + allStrings,
        missingStrings: counter.missingStrings + missingStrings
      };
    },
    { allStrings: 0, missingStrings: 0 }
  );
